/* eslint-disable @typescript-eslint/no-unused-vars */
import { EventsStringService } from "src/app/shared/services/events-string.service";
import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_COLORS, BLOCKLY_DUMMY, BLOCKLY_LABEL_PROPERTES, BlocklyToolboxCategory, PROPERTIES_FOR_EVENTS } from "../blocky-types.types";

export function BlocklyCategory_VIEW_FUSION_VIMEO(name: string = "unnamed", BH: BlocklyHelperService, eventStringService: EventsStringService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.FUSION, name: name, contents: [] };
  const secondsArray = Array.from({ length: 60 }, (_, i) => i.toString());
  const volumeArray = Array.from({ length: 101 }, (_, i) => i.toString());
  const timeSelectors = "{{hh:dropdown=0,1,2,3}}:{{mm:dropdown=" + secondsArray.join(',') + " }}:{{ss:dropdown=" + secondsArray.join(',') + "}}";


  cat.contents = [
    BH.label("Bot-Ansichten -> " + name),
    BH.action("VIMEO_GO_TO", "Vimeo Springe zu (" + timeSelectors + ")", "await RAGAI.VIMEO.seekTo({{hh}},{{mm}},{{ss}}); "),
    BH.action("VIMEO_SPEED", "Vimeo Wiedergabegeschwindigkeit: {{speed:dropdown=0.5,0.75,1,1.25,1.5,1.75,2}}", "await RAGAI.VIMEO.setPlaybackRate({{speed}});"),
    BH.action("VIMEO_VOLUME", "Vimeo Lautstärke: {{speed:dropdown=" + volumeArray.join(',') + "}}", "await RAGAI.VIMEO.setVolume({{speed}});"),
    BH.actionDropdown("VIMEO_ACTIONS", "Vimeo", [
      ["Play()", "await RAGAI.VIMEO.play();"],
      ["Pause()", "await RAGAI.VIMEO.pause();"]
    ]),
    BH.withNested(BH.action("VIMEO_LOAD_VIDEO", "Vimeo Video Laden: {{value}}", "await RAGAI.VIMEO.loadVideo({{value}});", true), [{ forValue: 'value', isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }]),
    BH.action("VIMEO_LOOP", `Vimeo Loop: {{loop:dropdown=${["aktivieren", "deaktivieren"].join(',')}}}`, `await RAGAI.VIMEO.setLoop("{{loop}}" === "aktivieren");`),
    { kind: 'label', text: 'Ereignisse' },
    BH.withNested(
      BH._custom("VIMEO_EVENT_ON_TIME_HOOK", "bei Vimeo:\nEreignis-ID: {{?eventId}}\nPlayer-Zeit: {{mode:dropdown=nach|>,vor|<,genau|==}} (" + timeSelectors + ")\n{{action:statement[@check=ACTION]}} {{callonce:checkbox}} Einmalig ausführen",
        `RAGAI.VARIABLES[{{eventId}}] = RAGAI.EVENTS.on('RAGAI.VIMEO.playpositionchanged',
      async function (_, data) {
        const seconds = Math.floor(data.seconds);
        const fraction = data.seconds - seconds;
        if (seconds {{mode}} RAGAI.HELPER.timeToSeconds({{hh}},{{mm}},{{ss}}) && fraction <= 0.25) {
          {{action}}
          if({{callonce}}){
            RAGAI.EVENTS.off(RAGAI.VARIABLES[{{eventId}}]);
            delete RAGAI.VARIABLES[{{eventId}}];
          }
        }
      });`,
        PROPERTIES_FOR_EVENTS),
      [{ forValue: "eventId", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }]
    ),
    BLOCKLY_LABEL_PROPERTES,
    BH.propertyDropdown(
      "VIMEO_PROPERITES",
      "Vimeo",
      [
        ["position", "await RAGAI.VIMEO.currentPlayPosition()"]
      ]),
    BH.eventDropdown("VIMEO_EVENTS", eventStringService.get("RAGAI.VIMEO.")),
    BH.eventDropdown("VIMEO_EVENTS_RAW", eventStringService.getRaw("RAGAI.VIMEO."))
  ];
  return cat;
}
